import { Box, Button, TextField, Typography } from "@mui/material";
import { useState } from "react";

const AddService = () => {
    const [serviceName, setserviceName] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const [error, setError] = useState("");

    const handleAddService = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        // console.log(serviceName);
        if (serviceName.trim() === "") { // Check for empty string
            setError("Please Enter a Service name"); // Set error message
            setIsLoading(false); // Ensure loading state is reset
            return; // Exit the function early
        }
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/create_product', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({  "name": serviceName }),
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setError("Service Added Successfully");
                window.location.reload();
            } else {
                setError('Failed to post data');
                throw new Error('Failed to post data');
            }
        } catch (err) {
            console.error('Error getting data:', err);
            setError(err.message);
        }finally {
            setIsLoading(false); 
        }
    };
    return (
        <Box sx={{
            p: 2,
            width: "320px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            backgroundColor: "white",
            borderRadius: "10px"
        }}>
            <form onSubmit={handleAddService}>
                <TextField
                    placeholder="Service Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={serviceName}
                    onChange={(e) => setserviceName(e.target.value)}
                // sx={{ fontSize: { xs: "0.875rem", md: "1rem" } }}
                />
                {error && (
                    <Typography color="error" sx={{ fontSize: "0.875rem", mt: 1 }}>
                        {error}
                    </Typography>
                )}
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={isLoading}
                    sx={{
                        mt: 2,
                        // fontSize: { xs: "0.875rem", md: "1rem" } 
                        fontWeight: "bold"
                    }}
                >
                    {isLoading ? "Adding..." : "Add Service Name"}
                </Button>
            </form>
        </Box>
    )
};
export default AddService;